import React from "react";
import { ReactFlowCanvasContext } from "../ReactFlowCanvasContext";

export function useReactFlowCanvasState() {
  return React.useContext(ReactFlowCanvasContext);
}
